const catNames = {
  SP_MONTHLY: 'spMonthly',
  BILLING: 'billing',
  TRACKING: 'tracking',
  TICKETS_MONTHLY: 'ticketsMonthly',
  AI_BILLING: 'aiBilling',
  AI_SP_MONTHLY: 'aiSpMonthly',
  AI_TRACKING: 'aiTracking',
  AI_TICKET_SP: 'aiTicketSP'
}

const catOptions = {
  [catNames.BILLING]: {
    graphInfo: {
      graphTitle: 'Support Billing Per Month',
      graphTitleX: 'Month',
      graphTitleY: 'Dollars'
    },
    tabLabels: {
      averageLabel: 'Average $/Month',
      units: 'Dollars',
      unitSign1: '$',
      unitSign2: ''
    }
  },
  [catNames.TRACKING]: {
    graphInfo: {
      graphTitle: 'SP Per Sprint',
      graphTitleX: 'Month',
      graphTitleY: 'Story Points'
    },
    tabLabels: {
      averageLabel: 'Average SP/Month',
      units: 'Story Points',
      unitSign1: '',
      unitSign2: 'SP'
    }
  },
  [catNames.SP_MONTHLY]: {
    graphInfo: {
      graphTitle: 'Dollar/SP Per Month',
      graphTitleX: 'Month',
      graphTitleY: 'Dollar Per SP'
    },
    tabLabels: {
      averageLabel: 'Average $/SP',
      units: 'Dollars / Story Point',
      unitSign1: '$',
      unitSign2: '/SP'
    }
  },
  [catNames.TICKETS_MONTHLY]: {
    graphInfo: {
      graphTitle: 'Tickets Per Month',
      graphTitleX: 'Month',
      graphTitleY: 'Ticket Count'
    },
    tabLabels: {
      averageLabel: 'Average Tickets/Month',
      units: 'Tickets / Month',
      unitSign1: '',
      unitSign2: ''
    }
  },
  [catNames.AI_BILLING]: {
    graphInfo: {
      graphTitle: 'QBO Billing Per Month',
      graphTitleX: 'Month',
      graphTitleY: 'Dollars (QBO)'
    },
    tabLabels: {
      averageLabel: 'Average $/Month (QBO)',
      units: 'Dollars',
      unitSign1: '$',
      unitSign2: ''
    }
  },
  [catNames.AI_SP_MONTHLY]: {
    graphInfo: {
      graphTitle: 'Support Billing Per Month',
      graphTitleX: 'Month',
      graphTitleY: 'Dollars'
    },
    tabLabels: {
      averageLabel: 'Average $/Month',
      units: 'Dollars',
      unitSign1: '$',
      unitSign2: ''
    }
  },
  [catNames.AI_TRACKING]: {
    graphInfo: {
      graphTitle: 'SP Per Sprint',
      graphTitleX: 'Month',
      graphTitleY: 'Story Points'
    },
    tabLabels: {
      averageLabel: 'Average SP/Month',
      units: 'Story Points',
      unitSign1: '',
      unitSign2: 'SP'
    }
  },
  [catNames.AI_TICKET_SP]: {
    graphInfo: {
      graphTitle: 'SP per Zendesk Ticket Per Month',
      graphTitleX: 'Month',
      graphTitleY: 'SP per ZD ticket'
    },
    tabLabels: {
      averageLabel: 'Avg. SP/ZD ticket',
      units: 'Story Points',
      unitSign1: '',
      unitSign2: 'SP/ZD ticket'
    }
  }
}

const qboCharges = {
  INTMGR_TRANSACTIONS: 'IntMgr Transactions',
  SUPPORT_RETAINER: 'Support - Retainer',
  WORKFLOW: 'Workflow',
  SUPPORT_AYCE: 'Support - AYCE',
  SUPPORT_PER_OCCURRENCE: 'Support - Per Occurrence',
  HOSTING_INFRASTRUCTURE: 'Hosting/Infrastructure',
  SUPPORT_TM: 'Support - T/M',
  SUPPORT_HOSTING_INFRASTRUCTURE: 'Support - Hosting/Infrastructure',
  BEVYTEC_TRANSACTIONS: 'BevyTec Transactions',
  INTMGR: 'IntMgr',
  // UNDEFINED: 'undefined',
  SUPPORT: 'Support',
  MTPP: 'MTPP',
  DOKSHARE: 'Dokshare'
}

const allCharges = [
  qboCharges.INTMGR_TRANSACTIONS,
  qboCharges.SUPPORT_RETAINER,
  qboCharges.WORKFLOW,
  qboCharges.SUPPORT_AYCE,
  qboCharges.SUPPORT_PER_OCCURRENCE,
  qboCharges.HOSTING_INFRASTRUCTURE,
  qboCharges.SUPPORT_TM,
  qboCharges.SUPPORT_HOSTING_INFRASTRUCTURE,
  qboCharges.BEVYTEC_TRANSACTIONS,
  qboCharges.INTMGR,
  qboCharges.SUPPORT,
  qboCharges.MTPP,
  qboCharges.DOKSHARE,
  qboCharges.UNDEFINED
]

const graphFilters = {
  SUPPORT: 'support',
  VULNERABILITIES: 'vulnerabilities',
  UPGRADES: 'upgrades'
}

const graphRegex = {
  [graphFilters.SUPPORT]: /\bsupport\b/i,
  [graphFilters.VULNERABILITIES]: /\b(vulnerabilit(?:y|ies)|dependenc(?:y|ies)?)\b/i,
  [graphFilters.UPGRADES]: /\bupgrade(?:s)?\b/i
}

export { catNames, catOptions, graphFilters, graphRegex, qboCharges, allCharges }
